import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
import {
  VirtualTableColumnDef as ColumnDef,
  ColumnDefMeta,
} from 'core/components/VirtualTable/types';
import {
  formatMoney,
} from '@populateui/utils';

type Props<T> = {
  value?: number | null;
  columnDef?: ColumnDef<T>;
  showZero?: boolean;
  showNegative?: boolean;
  block?: boolean;
  addorment?: ReactNode;
  suggestedValue?: number | null;
  disabled?: boolean;
};

const indicatorClassName = 'absolute w-0 h-0 border-t-solid border-r-solid border-r-transparent border-t-8 border-r-8';

export default function AmountCell<T>({
  value,
  columnDef,
  showZero = false,
  showNegative = true,
  block = false,
  addorment = null,
  suggestedValue,
}: Props<T>) {
  const editable = Boolean((columnDef?.meta as ColumnDefMeta<string | number>)?.editable);
  const emptyValue = editable ? '' : '--';
  const isNegative = isNumber(value) && value < 0;
  const className = clsx('empty:hidden font-semibold relative', {
    '!text-red-500': isNegative,
  });

  return block ? (<div className="not-applicable" />)
    : (
      <>
        <span className={className}>
          {(value === 0 && !showZero) || isNil(value) ? emptyValue : formatMoney(value ?? 0)}
          {addorment}
        </span>
        {isNegative && showNegative && (
          <div className={clsx(indicatorClassName, 'top-0 left-0 border-t-red-500')} />
        )}
        {!isNil(suggestedValue) && suggestedValue !== Number(value ?? 0) && (
          <div className={clsx(indicatorClassName, ' -top-1 -left-1 !m-0 border-t-blue-500')} />
        )}
      </>
    );
}
